import { Component, OnInit, ViewEncapsulation, OnDestroy } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { ActivatedRoute } from "@angular/router";
import {
  faArrowCircleLeft,
  faArrowCircleRight,
} from "@fortawesome/pro-solid-svg-icons";
import { Store } from "@ngrx/store";
import { AppService } from "src/app/app.service";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { VSConsensusPageDataService } from "../vsconsensus-page-data.service";
import { Subscription } from "rxjs";

@Component({
  selector: "app-vsconsensus-page",
  templateUrl: "./vsconsensus-page.component.html",
  styleUrls: ["./vsconsensus-page.component.scss"],
  host: { class: "vsconsensus-page-component" },
  encapsulation: ViewEncapsulation.None,
})
export class VSConsensusPageComponent implements OnInit, OnDestroy {
  vsconsensusMeta: any = {
    filters: {
      percentChange: "default",
      filterLineItem: "",
    },
  };

  gridFilters = {
    vsConsensus: "default",
    filterLineItem: "",
    cut_expansions: [],
    showYoY: false,
  };

  disabledSidebar = false;
  isRightsideBarCollapsed = true;
  showRightSidebar = true;
  faArrowCircleLeft = faArrowCircleLeft;
  faArrowCircleRight = faArrowCircleRight;
  ticker = "";
  tickerFullName = "";
  showClear = false;
  metaSubscriber: Subscription;
  pageParamsSubcription: Subscription;
  constructor(
    private dataService: VSConsensusPageDataService,
    private store: Store<AppState>,
    private route: ActivatedRoute,
    private titleService: Title,
    private appService: AppService,
  ) {}

  ngOnInit() {
    this.pageParamsSubcription = this.store
      .select(stateGetter("navigationSettings", "pageParams", "ticker"))
      .subscribe((ticker: string) => {
        if (ticker) {
          this.ticker = ticker;
          this.getVSConsensusMeta();
        }
      });

    this.store.select(stateGetter("globalSubheader")).subscribe((resp) => {
      this.tickerFullName = resp.subheaderTitle;
    });

    //set page title
    this.route.params.subscribe((params) => {
      this.titleService.setTitle(
        `VSConsensus - ${params.ticker.toUpperCase()}`,
      );
    });

    this.logUserAction();
  }

  ngOnDestroy() {
    if (this.metaSubscriber) {
      this.metaSubscriber.unsubscribe();
    }
    if (this.pageParamsSubcription) {
      this.pageParamsSubcription.unsubscribe();
    }
  }

  getVSConsensusMeta() {
    this.dataService.getVSConsensusMeta(this.ticker).subscribe((response) => {
      const rightPanelLoaded = this.store
        .select(stateGetter("rightPanel", "sourceMeta", "loaded"))
        .subscribe((loaded: boolean) => {
          if (!loaded) {
            // return;
          }

          const vsconsensusMeta = response;

          //setting default filters
          this.vsconsensusMeta = vsconsensusMeta;
          this.vsconsensusMeta.tickerFullName = this.tickerFullName;
          this.vsconsensusMeta.ticker = this.ticker;

          this.gridFilters = JSON.parse(
            JSON.stringify(this.vsconsensusMeta.filters),
          );
          if (
            !this.vsconsensusMeta.filters.cut_expansions ||
            this.vsconsensusMeta.filters.cut_expansions.length === 0
          ) {
            this.vsconsensusMeta.filters.cut_expansions = [
              this.vsconsensusMeta.tabs[0].name,
            ];
            this.gridFilters.cut_expansions = [
              this.vsconsensusMeta.tabs[0].name,
            ];
          } else {
            this.gridFilters.cut_expansions =
              this.vsconsensusMeta.filters.cut_expansions;
          }
          this.gridFilters.vsConsensus = this.gridFilters.vsConsensus
            ? this.gridFilters.vsConsensus
            : "default";
          this.gridFilters.showYoY = this.gridFilters.showYoY || false;
          this.gridFilters.filterLineItem =
            this.gridFilters.filterLineItem || "";
        });
      if (rightPanelLoaded) {
        rightPanelLoaded.unsubscribe();
      }
    });
  }

  onClearLineitemSearch(vsconsensusGrid) {
    this.gridFilters.filterLineItem = "";
    vsconsensusGrid.onFilterChange(["lineitem"]);
  }

  onFilterChange(isSwitchOn: boolean, property: string) {
    this.gridFilters[property] = isSwitchOn;
    this.gridFilters = Object.assign({}, this.gridFilters);

    const defaultGridFilters = {
      vsConsensus: "default",
      filterLineItem: "",
      cut_expansions: ["Monitor"],
      showYoY: false,
    };

    // // true -> Don;t set clear Flag
    // // false -> set clear Flag
    const diffInFilter = this.appService.compare(
      defaultGridFilters,
      this.gridFilters,
    );

    this.showClearFilter(!diffInFilter);

    this.appService.logUserAction(
      {},
      this.ticker,
      null,
      "Show only",
      { beginning_state_referrer: "VSConsensus Page" },
      "",
      "VSConsensus Toggle click",
    );

    const jsonData = { filters: this.gridFilters };
    this.dataService.saveUserFilters(jsonData, this.ticker).subscribe();
  }

  logUserAction() {
    const today = new Date();
    const currentTime = today.toUTCString();
    const currentURL = window.location.href;
    this.appService.logUserAction(
      {},
      this.ticker,
      "",
      "VSConsensus Page",
      {
        PAGE: "VSConsensus Page",
        UTCTIME: currentTime,
        URL: currentURL,
        VALUE: this.ticker,
        beginning_state_referrer: "Company page",
      },
      "",
      "Left panel click",
    );
  }

  rightSiderCollapseChanged(isCollapsed) {
    this.logRpExpansionState(isCollapsed);
  }

  logRpExpansionState(isCollapsed) {
    this.appService.logUserAction(
      `RIGHT_PANEL_${isCollapsed ? "COLLAPSE" : "EXPAND"}`,
      this.ticker,
      "",
      `RIGHT_PANEL_${isCollapsed ? "COLLAPSE" : "EXPAND"}`,
      {
        company: this.ticker,
      },
      "",
      "RIGHT_PANEL_CLICK",
    );
  }

  onClearClick() {
    const deleteHistoryObj = {
      viewdata: {
        company: this.ticker,
        cut: null,
        source: null,
        jsonData: {},
        type: 5,
        dimension: "",
      },
    };

    this.dataService.clearFilter(deleteHistoryObj).subscribe((response) => {
      if (response && response["status"] === "success") {
        if (this.ticker !== undefined) {
          this.getVSConsensusMeta();
        }
        this.showClear = false;
      }
    });
  }

  showClearFilter(status) {
    this.showClear = status;
  }
}
